import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import VendorsService from "./VendorsService";

export const GetAllVendors = createAsyncThunk(
    "vendors/getAll",
    async (_, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await VendorsService.GetAllVendors(token);
        } catch (error) {
            const massage = error.response;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

export const CerateNewVendor = createAsyncThunk(
    "vendors/create",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await VendorsService.CerateNewVendor(data, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.error);
        }
    }
);

export const UpdateVendorData = createAsyncThunk(
    "vendors/update",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await VendorsService.UpdateVendorData(data, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.error);
        }
    }
);

export const GetSingleVendor = createAsyncThunk(
    "vendors/create",
    async (id, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return await VendorsService.GetSingleVendor(id, token);
        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data?.error);
        }
    }
);

export const DeleteVendorAction = createAsyncThunk(
    "vendors/delete",
    async (data, thunkAPI) => {
        try {
            let token = thunkAPI.getState().auth.mainUser.data.token;
            return await VendorsService.DeleteVendorAction(data, token);
        } catch (error) {
            let massage = error.response;
            return thunkAPI.rejectWithValue(massage);
        }
    }
);

// Vendors States Methods 
export const DeleteStateAction = createAsyncThunk(
    'state/delete',
    async (state_id, thunkAPI) => {
        try {
            let token = thunkAPI.getState().auth.mainUser.data.token;
            return await VendorsService.DeleteStateAction(state_id, token)
        } catch (error) {
            let message = error.message;
            return thunkAPI.rejectWithValue(message)
        }
    }
)

const VendorsSlice = createSlice({
    name: "vendors",
    initialState: {
        vendors: null,
        vendor: null,
        message: null,
        isSuccess: false,
        isError: false,
        isLoading: false,
        errors: null,
        stateSuccess: false,
        stateLoading: false,
    },
    reducers: {
        resetVendors: (state) => {
            state.isSuccess = false;
            state.isLoading = false;
            state.isError = false;
            state.message = null;
            state.errors = null;
        },
    },
    extraReducers: {
        // Get All Vendors Extra
        [GetAllVendors.pending]: (state) => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
        },
        [GetAllVendors.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.vendors = action.payload;
            state.isSuccess = true;
            state.isError = false;
        },
        [GetAllVendors.rejected]: (state) => {
            state.isError = true;
            state.isLoading = false;
            state.isSuccess = false;
        },

        // Create New Vendor Extra
        [CerateNewVendor.pending]: (state) => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
        },
        [CerateNewVendor.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.vendors = action.payload;
            state.isSuccess = true;
            state.isError = false;
        },
        [CerateNewVendor.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.isSuccess = false;
            state.errors = action.payload;
        },

        
        // Update New Vendor Extra
        [UpdateVendorData.pending]: (state) => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
        },
        [UpdateVendorData.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.vendors = action.payload;
            state.isSuccess = true;
            state.isError = false;
        },
        [UpdateVendorData.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.isSuccess = false;
            state.errors = action.payload;
        },

        // Get Vendor Extra
        [GetSingleVendor.pending]: (state) => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
        },
        [GetSingleVendor.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.vendor = action.payload;
            state.isSuccess = true;
            state.isError = false;
        },
        [GetSingleVendor.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.isSuccess = false;
            state.errors = action.payload.data.error;
        },
    },

    // Delete Vendor State Extra
    [DeleteStateAction.pending]: (state) => {
        state.stateLoading = true;
    },
    [DeleteStateAction.fulfilled]: (state, action) => {
        state.stateLoading = false;
        state.stateSuccess = true;
    },
    [DeleteStateAction.rejected]: (state, action) => {
        state.isError = true;
        state.stateLoading = false;
        state.errors = action.payload.data.error;
    },
    
});

export const { resetVendors } = VendorsSlice.actions;
export default VendorsSlice.reducer;
